import NetxQueryClient, {
	SuccessResponse,
} from '@netx/core-next/lib/queryClient';
export type {QueryError} from '@netx/core-next/lib/queryClient';

import {AttributePermission} from '../types';

/**
 * `getAttributePermissions` request params
 * (what is used to send to server)
 */
export type GetAttributePermissionsRequestOptions = Pick<
	AttributePermission,
	'templateId'
>;

/**
 * `getAttributePermissions` request
 * (what gets sent to the server)
 */
export type GetAttributePermissionsRequest = [
	GetAttributePermissionsRequestOptions['templateId'],
];

/**
 * `getAttributePermissions` response
 * (what comes back from the server)
 */
export type GetAttributePermissionsResponse =
	SuccessResponse<GetAttributePermissionsResult>;

/**
 * `getAttributePermissions` result
 * (what is utilized from the server response)
 */
export type GetAttributePermissionsResult = AttributePermission[];

export const getAttributePermissionsEndpoint = 'getAttributePermissions';

/**
 * Get attribute permissions
 */
export const getAttributePermissions = async ({
	templateId,
}: GetAttributePermissionsRequestOptions) => {
	const client = NetxQueryClient();

	const requestParams: GetAttributePermissionsRequest = [templateId];

	return client
		.post<GetAttributePermissionsResponse>(
			getAttributePermissionsEndpoint,
			requestParams,
		)
		.then((response) => response.data.result);
};

export default getAttributePermissions;
